export default "__VITE_ASSET__BmKMEAlj__"